export const [
  headerBg,
  headerText,
  headerTextHover,
  headerAccent,
  headerLightText,
  bgAccentTabs,
  bgAccentMain,
  bgAdditional,
  bgMain,
  leaderQilinNormal,
  leaderQilinBg,
  leaderDragonNormal,
  leaderDragonBg,
  leaderPhoenixNormal,
  leaderPhoenixBg,
  textPrimary,
  textSecondary,
  errorNormal,
  errorHover,
  errorDisabled,
  warningNormal,
  warningHover,
  warningDisabled,
  successNormal,
  successHover,
  successDisabled,
  focusNormal,
  focusHover,
  focusDisabled,
  focusSelected,
  btnPrimaryNormal,
  btnPrimaryHover,
  btnPrimaryDisabled,
  btnPrimarySelected,
  btnSecondaryNormal,
  btnSecondaryHover,
  btnSecondaryDisabled,
  btnSecondarySelected,
  btnSecondaryNormalBorder,
  btnSecondaryHoverBorder,
  btnSecondaryDisabledBorder,
  btnSecondarySelectedBorder,
  btnSanriseBg,
  btnSanriseBorder,
  btnSansetBg,
  btnSansetBorder,
  signalBtnLightNormal,
  signalBtnLightHover,
  signalBtnLightSelected,
  signalBtnLightDisabled,
  signalBtnLightGreen,
  signalBtnLightRed,
  privateMain,
  privateMainHover,
  privateMainDisabled,
  privateMainSelected,
  privateBg,
  graph,

  athens,
  azure,
  azureAccent,
  azureHover,
  azure01,
  azure02,
  bleach,
  blue,
  blueHover,
  blue01,
  blue02,
  blue03,
  blue04,
  browny,
  browny01,
  casper,
  fiord,
  green,
  greenAccent,
  greenHover,
  green01,
  green02,
  green03,
  green04,
  heliotrope,
  heliotropeHover,
  heliotrope01,
  heliotrope02,
  heliotrope03,
  heliotrope04,
  lima,
  limaHover,
  lima01,
  lima02,
  mirage,
  mystic,
  orange,
  orangeHover,
  orangePale,
  orange01,
  orange02,
  orange03,
  porcelain,
  red,
  redHover,
  red01,
  red02,
  red03,
  red04,
  rhino,
  shark,
  sheets,
  sheetsHover,
  yellow,
  yellowHover,
  yellow01,
  yellow02,
  waterloo,
] = [
  'var(--headerBg)',
  'var(--headerText)',
  'var(--headerTextHover)',
  'var(--headerAccent)',
  'var(--headerLightText)',
  'var(--bgAccentTabs)',
  'var(--bgAccentMain)',
  'var(--bgAdditional)',
  'var(--bgMain)',
  'var(--leaderQilinNormal)',
  'var(--leaderQilinBg)',
  'var(--leaderDragonNormal)',
  'var(--leaderDragonBg)',
  'var(--leaderPhoenixNormal)',
  'var(--leaderPhoenixBg)',
  'var(--textPrimary)',
  'var(--textSecondary)',
  'var(--errorNormal)',
  'var(--errorHover)',
  'var(--errorDisabled)',
  'var(--warningNormal)',
  'var(--warningHover)',
  'var(--warningDisabled)',
  'var(--successNormal)',
  'var(--successHover)',
  'var(--successDisabled)',
  'var(--focusNormal)',
  'var(--focusHover)',
  'var(--focusDisabled)',
  'var(--focusSelected)',
  'var(--btnPrimaryNormal)',
  'var(--btnPrimaryHover)',
  'var(--btnPrimaryDisabled)',
  'var(--btnPrimarySelected)',
  'var(--btnSecondaryNormal)',
  'var(--btnSecondaryHover)',
  'var(--btnSecondaryDisabled)',
  'var(--btnSecondarySelected)',
  'var(--btnSecondaryNormalBorder)',
  'var(--btnSecondaryHoverBorder)',
  'var(--btnSecondaryDisabledBorder)',
  'var(--btnSecondarySelectedBorder)',
  'var(--btnSanriseBg)',
  'var(--btnSanriseBorder)',
  'var(--btnSansetBg)',
  'var(--btnSansetBorder)',
  'var(--signalBtnLightNormal)',
  'var(--signalBtnLightHover)',
  'var(--signalBtnLightSelected)',
  'var(--signalBtnLightDisabled)',
  'var(--signalBtnLightGreen)',
  'var(--signalBtnLightRed)',
  'var(--privateMain)',
  'var(--privateMainHover)',
  'var(--privateMainDisabled)',
  'var(--privateMainSelected)',
  'var(--privateBg)',
  'var(--graph)',

  'var(--athens)',
  'var(--azure)',
  'var(--azureAccent)',
  'var(--azureHover)',
  'var(--azure01)',
  'var(--azure02)',
  'var(--bleach)',
  'var(--blue)',
  'var(--blueHover)',
  'var(--blue01)',
  'var(--blue02)',
  'var(--blue03)',
  'var(--blue04)',
  'var(--browny)',
  'var(--browny01)',
  'var(--casper)',
  'var(--fiord)',
  'var(--green)',
  'var(--greenAccent)',
  'var(--greenHover)',
  'var(--green01)',
  'var(--green02)',
  'var(--green03)',
  'var(--green04)',
  'var(--heliotrope)',
  'var(--heliotropeHover)',
  'var(--heliotrope01)',
  'var(--heliotrope02)',
  'var(--heliotrope03)',
  'var(--heliotrope04)',
  'var(--lima)',
  'var(--limaHover)',
  'var(--lima01)',
  'var(--lima02)',
  'var(--mirage)',
  'var(--mystic)',
  'var(--orange)',
  'var(--orangeHover)',
  'var(--orangePale)',
  'var(--orange01)',
  'var(--orange02)',
  'var(--orange03)',
  'var(--porcelain)',
  'var(--red)',
  'var(--redHover)',
  'var(--red01)',
  'var(--red02)',
  'var(--red03)',
  'var(--red04)',
  'var(--rhino)',
  'var(--shark)',
  'var(--sheets)',
  'var(--sheetsHover)',
  'var(--yellow)',
  'var(--yellowHover)',
  'var(--yellow01)',
  'var(--yellow02)',
  'var(--waterloo)',
];

export const colors = {
  [headerBg]: '#242630',
  [headerText]: '#E6E9F4',
  [headerTextHover]: '#FFFFFF',
  [headerAccent]: '#101216',
  [headerLightText]: '#6E778D',
  [bgAccentTabs]: ['#E3E5EE', '#424554'],
  [bgAccentMain]: ['#FFFFFF', '#101216'],
  [bgAdditional]: ['#FCFCFC', '#1E2028'],
  [bgMain]: ['#F5F7F9', '#1E2028'],
  [leaderQilinNormal]: '#006CCF',
  [leaderQilinBg]: '#F7FBFF',
  [leaderDragonNormal]: '#1BAF33',
  [leaderDragonBg]: '#F4FFF6',
  [leaderPhoenixNormal]: '#E97000',
  [leaderPhoenixBg]: '#FFFAF5',
  [textPrimary]: ['#313141', '#FFFFFF'],
  [textSecondary]: ['#6E778D', '#E6E9F4'],
  [errorNormal]: ['#D21C1C', '#D42020'],
  [errorHover]: ['#B91919', '#E12121'],
  [errorDisabled]: ['#FFEEEE', '#510606'],
  [warningNormal]: ['#DF7B00', '#DA7611'],
  [warningHover]: ['#C96F00', '#FF8000'],
  [warningDisabled]: ['#FFFAF5', '#3A2713'],
  [successNormal]: ['#28A138', '#22A530'],
  [successHover]: ['#238B31', '#2ED847'],
  [successDisabled]: ['#EBFDEB', '#24330C'],
  [focusNormal]: ['#0172CB', '#1982D8'],
  [focusHover]: ['#0161AC', '#008CFF'],
  [focusDisabled]: ['#F9FCFF', '#0C2E4A'],
  [focusSelected]: '#0C2E4A',
  [btnPrimaryNormal]: ['#242630', '#D7DFEF'],
  [btnPrimaryHover]: ['#0B0C0F', '#FFFFFF'],
  [btnPrimaryDisabled]: ['#EFF0F4', '#1E202B'],
  [btnPrimarySelected]: ['#DDE5EC', '#265CC64D'],
  [btnSecondaryNormal]: ['#FFFFFF', '#13151C'],
  [btnSecondaryHover]: ['#FFFFFF', '#101216'],
  [btnSecondaryDisabled]: ['#FDFDFD', '#1A1D29'],
  [btnSecondarySelected]: ['#E5EBF1', '#265CC633'],
  [btnSecondaryNormalBorder]: ['#ADB1C2', '#8E97AC'],
  [btnSecondaryHoverBorder]: ['#7A859E', '#FFFFFF'],
  [btnSecondaryDisabledBorder]: ['#F0F1F3', '#000000'],
  [btnSecondarySelectedBorder]: ['#A1ADC8', '#999DAF'],
  [btnSanriseBg]: ['#FFFFFF', '#FFFFFF'],
  [btnSanriseBorder]: ['#28A138', '#2D7738'],
  [btnSansetBg]: ['#FFFFFF', '#FFFFFF'],
  [btnSansetBorder]: ['#D21C1C', '#970C0C'],
  [signalBtnLightNormal]: ['#406EC7', '#406EC7'],
  [signalBtnLightHover]: ['#3363C1', '#3363C1'],
  [signalBtnLightSelected]: ['#739EF1', '#739EF1'],
  [signalBtnLightDisabled]: ['#BFD5FF', '#23314E'],
  [signalBtnLightGreen]: ['#00A58E', '#1E9786'],
  [signalBtnLightRed]: ['#E4645B', '#E95045'],
  [privateMain]: ['#71109F', '#C243FD'],
  [privateMainHover]: ['#6C0A8C', '#9424C8'],
  [privateMainDisabled]: ['#FAEDFF', '#3D0955'],
  [privateMainSelected]: ['#8E22C0', '#702196'],
  [privateBg]: ['#FAEDFF', '#3D0955'],
  [graph]: ['#D9DEE3', '#5F636E'],

  [athens]: ['#F3F4FA', '#1E2234'],
  [azure]: ['#72FFFF', '#72FFFF'],
  [azureAccent]: ['#EBFAFD', '#1F2B3B'],
  [azureHover]: ['#18C0E4', '#5BCDE5'],
  [azure01]: ['#EBFAFD', '#1F2B3B'],
  [azure02]: ['#D7F6FC', '#253A4B'],
  [bleach]: ['#FFFFFF', '#181B2B'],
  [blue]: ['#5275FF', '#5275FF'],
  [blueHover]: ['#375BE9', '#375BE9'],
  [blue01]: ['#ECF0FE', '#1D223E'],
  [blue02]: ['#DAE0FD', '#273160'],
  [blue03]: ['#A9BAFF', '#354895'],
  [blue04]: ['#8099FF', '#8099FF'],
  [browny]: ['#B76A50', '#BB7760'],
  [browny01]: ['#F3B9A4', '#F3B9A4'],
  [casper]: ['#9FAAC4', '#4E5472'],
  [fiord]: ['#505573', '#A2A7BD'],
  [green]: ['#14C393', '#297F69'],
  [greenAccent]: ['#8AFFCE', '#8AFFCE'],
  [greenHover]: ['#1FAC85', '#1FAC85'],
  [green01]: ['#EDF8F5', '#EDF8F5'],
  [green02]: ['#DCF6EF', '#DCF6EF'],
  [green03]: ['#B0EBDB', '#B0EBDB'],
  [green04]: ['#6CC5AE', '#297F69'],
  [heliotrope]: ['#8358FF', '#8358FF'],
  [heliotropeHover]: ['#6339DD', '#774EED'],
  [heliotrope01]: ['#F5F4FF', '#1D1E35'],
  [heliotrope02]: ['#E7E4FF', '#28244B'],
  [heliotrope03]: ['#D4C5FF', '#3E3075'],
  [heliotrope04]: ['#C1ABFF', '#4E3995'],
  [lima]: ['#26C953', '#26C953'],
  [limaHover]: ['#1BAD44', '#1BAD44'],
  [lima01]: ['#D6F6D6', '#1A3424'],
  [lima02]: ['#B4EFB4', '#215536'],
  [mirage]: ['#181b2b', '#F8F9FF'],
  [mystic]: ['#D2D6E7', '#343A52'],
  [orange]: ['#FFAD4D', '#FFAD4D'],
  [orangeHover]: ['#FD9317', '#FFA030'],
  [orangePale]: ['#FFF9F0', '#26242D'],
  [orange01]: ['#FFF3E4', '#3B3130'],
  [orange02]: ['#FFE7CA', '#503F3D'],
  [orange03]: ['#FFD6A6', '#2A262D'],
  [porcelain]: ['#ECEEF5', '#202436'],
  [red]: ['#FF6363', '#FF6363'],
  [redHover]: ['#F85454', '#F85454'],
  [red01]: ['#FFEEEE', '#2E2130'],
  [red02]: ['#FFCECE', '#4F2B36'],
  [red03]: ['#FFADAD', '#74353E'],
  [red04]: ['#FF8C8C', '#934853'],
  [rhino]: ['#2F354D', '#DFE1EC'],
  [shark]: ['#15181F', '#15181F'],
  [sheets]: ['#21B074', '#21B074'],
  [sheetsHover]: ['#158A59', '#158A59'],
  [yellow]: ['#21B074', '#21B074'],
  [yellowHover]: ['#FBB80D', '#FBB80D'],
  [yellow01]: ['#FFF5DA', '#2C2929'],
  [yellow02]: ['#FFE3A5', '#FFE3A5'],
  [waterloo]: ['#7A859E', '#7A809A'],
};
